import {
  Modal,
  Form,
  Button,
  Select,
  Typography,
  Empty,
  Space,
  Flex,
  Radio,
  message,
  Row,
  Col,
  Input,
  Table,
  Descriptions,
} from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import IntlMessage from '../../../components/IntlMessage';
import SearchBus from './SearchBusForm';
import busOrdersApi from '../../../api/bus_orders';
import dayjs from 'dayjs';
import customersApi from '../../../api/customers';
import Departure from './Departure';
import ReturnDestination from './ReturnDestination';
import {
  clearOrderValues,
  updateSearchBookingValues,
} from '../../../redux/actions/CreateBookingAction';
import { useDispatch, useSelector } from 'react-redux';
import useTime from '../../../hooks/useTime';
import { FrownOutlined } from '@ant-design/icons';
import LoadingContent from './Loading';
import PassengerInfo from './PassengerInfo';
import CountryData from '../../../utils/countrydata';
import { useIntl } from 'react-intl';

const { Title, Text } = Typography;

const BusOrderForm = (props) => {
  const { isModalForm, onModalFormClose, onRefresh, currentData } = props;
  const searchValues = useSelector(
    (state) => state.createBookings.searchValues
  );
  console.log('searchValuessearchValuessearchValuessearchValues', searchValues);
  const [paxQty, setPaxQty] = useState(1);
  const [departureSearchData, setDepartureSearchData] = useState([]);
  const [returnSearchData, setReturnSearchData] = useState([]);
  const [customersData, setCustomersData] = useState([]);
  const [customerSelectId, setCustomerSelectId] = useState(null);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const [isLoadingSearchResult, setIsLoadingSearchResult] = useState(false);
  const [isShowCustomerForm, setIsShowCustomerForm] = useState(false);
  const { formatAsISOString } = useTime();
  const dispatch = useDispatch();

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };
  const [filter, setFilter] = useState({
    page: 1,
    limit: 250,
    order_by: 'id',
    order_dir: 'DESC',
    keyword: '',
  });

  const isMounted = useRef(false);

  const fetchCustomers = useCallback(
    async (keyword = '') => {
      if (isMounted) {
        try {
          const newFilter = { ...filter, keyword };
          customersApi
            .getAll(newFilter)
            .then((res) => {
              setCustomersData(
                res.data.map((item, i) => {
                  return {
                    label: `${item?.fullname} - ${item?.mobile}`,
                    value: item?.id,
                  };
                })
              );
            })
            .catch((err) => console.log(err));
        } catch (err) {
          console.log(err);
        }
      }
    },
    [filter]
  );

  useEffect(() => {
    isMounted.current = true;

    fetchCustomers();
    return () => {
      isMounted.current = false;
    };
  }, [fetchCustomers, isMounted, searchValues?.customer]);

  const [form] = Form.useForm();

  const handleSearchCustomer = (value) => {
    fetchCustomers(value);
  };

  useEffect(() => {
    form.setFieldsValue({ pax: paxQty });
  }, [paxQty, form]);

  useEffect(() => {
    if (searchValues?.customer) {
      form.setFieldsValue({ customer_id: searchValues.customer.id });
    }
  }, [searchValues?.customer, form]);

  useEffect(() => {
    const fetch = async () => {
      const newFilter = {
        page: 1,
        limit: 1,
        filter_name: ['id'],
        filter_value: [customerSelectId],
      };
      customersApi
        .getAll(newFilter)
        .then((res) => {
          dispatch(
            updateSearchBookingValues({
              customer: res.data[0],
            })
          );
        })
        .catch((err) => console.log(err));
    };
    fetch();
  }, [customerSelectId, dispatch]);
  // const handleOk = () => {
  //   form
  //     .validateFields()
  //     .then(async (values) => {
  //       if (searchValues) {
  //         values.return_date = convertToAnyTimezone(
  //           searchValues.return_date
  //         ).format("YYYY-MM-DD");
  //         values.date = convertToAnyTimezone(searchValues.date).format(
  //           "YYYY-MM-DD"
  //         );
  //         values.roundtrip = searchValues.roundtrip;
  //         values.route_id = searchValues.route_id;
  //         values.pax = searchValues.pax;
  //         values.passengers = searchValues.passengers;
  //         values.notes = searchValues.notes;
  //         if (searchValues.roundtrip) {
  //           values.segments = [
  //             departure?.segments,
  //             returnDestination?.segments,
  //           ];
  //         } else {
  //           values.segments = [departure?.segments];
  //         }
  //       }

  //       const isDepartureInfoComplete =
  //         departure.selectedSeat_departure.length > 0;
  //       const isReturnInfoComplete =
  //         returnDestination?.selectedSeat_return?.length > 0;

  //       if (
  //         searchValues?.roundtrip
  //           ? isDepartureInfoComplete && isReturnInfoComplete
  //           : isDepartureInfoComplete
  //       ) {
  //         setIsLoadingSave(true);
  //         const res = await busOrdersApi.createBooking(values);
  //         if (res) {
  //           message.success("Create booking successfully!");
  //           setIsModalForm(false);
  //           onRefresh();
  //           setIsLoadingSave(false);
  //         } else {
  //           message.error("Seat is already taken");
  //         }
  //       } else {
  //         message.warning("Please fill in all the information");
  //       }
  //     })
  //     .catch((info) => {
  //       if (info.status === HTTP_STATUS_CONFLICT_CODE) {
  //         message.error(
  //           "Some of the seats you selected have already been taken"
  //         );
  //       }
  //       setIsLoadingSave(false);
  //       console.log("Validate Failed:", info);
  //     });
  // };

  const onRefreshData = () => {
    form.resetFields(['customer_id', 'notes']);
    dispatch(clearOrderValues());
  };

  const onChangeSelectCustomer = (value) => {
    setCustomerSelectId(value);
    dispatch(
      updateSearchBookingValues({
        customer_id: value,
      })
    );
  };

  const handleSearchOrder = (values, isOneWay) => {
    console.log('values', values);
    setIsLoadingSearchResult(true);
    !currentData && onRefreshData();
    const { from, to, date, pax } = values;
    if (pax) {
      setPaxQty(pax);
    }
    if (isOneWay) {
      const payload = {
        page: 1,
        limit: 9999,
        filter_name: ['from', 'to', 'date', 'pax'],
        filter_value: [from, to, dayjs(date).format('YYYY-MM-DD'), pax],
      };
      busOrdersApi
        .getBooking(payload)
        .then((res) => {
          console.log('res123123', res);

          if (currentData) {
            const data = res.filter(
              (item) =>
                item?.route?.operator?.id === currentData?.route?.operator?.id
            );
            setDepartureSearchData(data);
          } else {
            setDepartureSearchData(res);
          }
          setReturnSearchData([]);
          dispatch(
            updateSearchBookingValues({
              date: formatAsISOString(date),
              roundtrip: false,
              return_date: '',
              pax: pax,
            })
          );
          setShowSearchResult(true);
          setIsLoadingSearchResult(false);
        })
        .catch((error) => console.log('error', error));
    }
    // else {
    //   const departurePayload = {
    //     page: 1,
    //     limit: 9999,
    //     filter_name: ["from", "to", "date", "pax"],
    //     filter_value: [from, to, dayjs(date[0]).format("YYYY-MM-DD"), pax],
    //   };
    //   const returnPayload = {
    //     page: 1,
    //     limit: 9999,
    //     filter_name: ["from", "to", "date", "pax"],
    //     filter_value: [to, from, dayjs(date[1]).format("YYYY-MM-DD"), pax],
    //   };
    //   Promise.all([
    //     busOrdersApi.getBooking(departurePayload),
    //     busOrdersApi.getBooking(returnPayload),
    //   ])
    //     .then((res) => {
    //       setDepartureSearchData(res[0]);
    //       setReturnSearchData(res[1]);
    //       dispatch(
    //         updateSearchBookingValues({
    //           date: formatAsISOString(date[0]),
    //           roundtrip: true,
    //           return_date: formatAsISOString(date[1]),
    //           pax: pax,
    //         })
    //       );
    //       setShowSearchResult(true);
    //       setIsLoadingSearchResult(false);
    //     })
    //     .catch((error) => console.log(error));
    // }
  };

  useEffect(() => {
    console.log('handleSearchOrder curr', currentData);
    if (currentData) {
      handleSearchOrder(
        {
          from: currentData?.order_items[0]?.segment?.start_stop?.id,
          to: currentData?.order_items[0]?.segment?.end_stop?.id,
          date: currentData.date,
          pax: currentData.qty,
        },
        true
      );
      dispatch(
        updateSearchBookingValues({
          customer_id: currentData?.customer?.id,
        })
      );
    }
  }, [currentData]);

  const [isOpenPassenger, setIsOpenPassenger] = useState(false);
  const [isShowPassenger, setIsShowPassenger] = useState(false);
  console.log('currentData', currentData);

  const [segment, setSegment] = useState(null);
  const [payMethods, setPaymentMethods] = useState(null);

  const handleSelectSegment = (segment) => {
    setSegment(segment);
  };
  useEffect(() => {
    const fetch = async () => {
      busOrdersApi
        .getPaymentMethodOperator(segment?.route?.operator?.id)
        .then((res) => {
          console.log('payMethods1', res);
          setPaymentMethods(res);
        })
        .catch((err) => console.log(err));
    };
    segment?.route?.operator?.id && fetch();
  }, [segment]);
  const { convertToAnyTimezone } = useTime();
  const departure = useSelector((state) => state.createBookings.departure);
  const returnDestination = useSelector((state) => state.createBookings.return);
  const [payMethod, setPaymentMethod] = useState('');
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const intl = useIntl();
  const onChangePaymentMethod = (e) => {
    console.log('radio checked', e.target.value);
    setPaymentMethod(e.target.value);
  };

  const handleCreateBooking = () => {
    if (!searchValues?.passengers || searchValues?.passengers.length <= 0) {
      return message.warning(
        'Veuillez remplir les informations sur les passagers'
      );
    }

    if (departure?.selectedSeat_departure?.length !== paxQty) {
      return message.warning(
        `Merci de choisir ${
          Number(paxQty) - Number(departure?.selectedSeat_departure?.length)
        } siège(s)`
      );
    }

    form
      .validateFields()
      .then(async (values) => {
        if (searchValues) {
          console.log('searchValues', searchValues);
          values.return_date = convertToAnyTimezone(
            searchValues.return_date
          ).format('YYYY-MM-DD');
          values.date = convertToAnyTimezone(searchValues.date).format(
            'YYYY-MM-DD'
          );

          values.roundtrip = searchValues.roundtrip;
          values.route_id = searchValues.route_id;
          values.pax = searchValues.pax;
          values.passengers = searchValues?.passengers.map((v) => {
            let phone_code = '';
            console.log('v.phoneCode', v.phone_code);
            if (v.phone_code?.startsWith('+')) {
              phone_code = v.phone_code.slice(1);
              console.log('phoneCode', phone_code);
            } else {
            }
            return {
              ...v,
              phone: phone_code + v.mobile,
            };
          });
          values.customer_id = 11111;
          if (searchValues.roundtrip) {
            values.segments = [
              departure?.segments,
              returnDestination?.segments,
            ];
          } else {
            values.segments = [departure?.segments];
          }
        }

        const isDepartureInfoComplete =
          departure.selectedSeat_departure.length > 0;
        const isReturnInfoComplete =
          returnDestination?.selectedSeat_return?.length > 0;

        if (
          searchValues?.roundtrip
            ? isDepartureInfoComplete && isReturnInfoComplete
            : isDepartureInfoComplete
        ) {
          setIsLoadingSave(true);
          if (currentData) {
            console.log('values', values);
            const res = await busOrdersApi.updateBooking(
              values,
              currentData.id
            );
            if (res) {
              message.success('update booking successfully!');
              setIsLoadingSave(false);
              setIsOpenPassenger(false);
              onModalFormClose();
              onRefresh();
            }
          } else {
            const res = await busOrdersApi.createBooking(values);
            if (res) {
              if (payMethod === 'wave' && segment?.route?.operator?.id) {
                const data = {
                  booking_id: res.id,
                  company_id: segment?.route?.operator?.id,
                  phone: '+221' + form.getFieldValue('mobile'),
                };
                const res_pay = await busOrdersApi.paymentWave(data);
                if (res_pay) {
                  message.success('Create booking and send SMS successfully!');
                  setIsLoadingSave(false);
                  setIsOpenPassenger(false);
                  onModalFormClose();
                  onRefresh();
                } else {
                  message.error('send SMS fail!');
                  setIsLoadingSave(false);
                  setIsOpenPassenger(false);
                  onModalFormClose();
                  onRefresh();
                }
              } else if (
                payMethod === 'orangemoney' &&
                segment?.route?.operator?.id
              ) {
                const data = {
                  booking_id: res.id,
                  company_id: segment?.route?.operator?.id,
                  phone: '+221' + form.getFieldValue('mobile'),
                };
                const res_pay = await busOrdersApi.paymentOm(data);
                if (res_pay) {
                  message.success('Create booking and send SMS successfully!');
                  dispatch(clearOrderValues({ data: 1 }));
                  setIsLoadingSave(false);
                  setIsOpenPassenger(false);
                  onModalFormClose();
                  onRefresh();
                  form.resetFields();
                } else {
                  message.error('send SMS fail!');
                  setIsLoadingSave(false);
                  setIsOpenPassenger(false);
                  onModalFormClose();
                  onRefresh();
                }
              } else {
                message.success('Create booking successfully!');
                setIsLoadingSave(false);
                setIsOpenPassenger(false);
                onModalFormClose();
                onRefresh();
              }
            } else {
              message.error('Seat is already taken');
            }
          }
        } else {
          message.warning('Please fill in all the information');
        }
      })
      .catch((info) => {
        if (info.status === 600) {
          message.error(
            'Some of the seats you selected have already been taken'
          );
        } else {
          message.error(info?.data?.message || 'Update failed');
        }
        setIsLoadingSave(false);
        console.log('Validate Failed:', info);
      });
  };

  const [indexEditassenger, setIndexEditPassenger] = useState(null);

  const columns = [
    {
      title: 'Nom',
      dataIndex: 'fullname',
      render: (_, record) => {
        return record.firstname && record.lastname
          ? `${record.firstname}  ${record.lastname}`
          : '';
      },
    },
    {
      title: 'Téléphone',
      dataIndex: 'phone',
    },
    {
      title: 'Passeport',
      dataIndex: 'passport',
    },
    {
      title: '',
      dataIndex: '',
      render: (_, record, index) => {
        return (
          <Button
            type="primary"
            onClick={() => {
              setIsOpenPassenger(true);
              setIndexEditPassenger(index);
            }}
            size="small">
            <IntlMessage id="global.edit" />
          </Button>
        );
      },
    },
  ];

  const columnsAddPassenger = [
    {
      title: 'Nom',
      dataIndex: 'fullname',
      render: (_, record) => {
        return record.firstname && record.lastname
          ? `${record.firstname}  ${record.lastname}`
          : '';
      },
    },
    {
      title: 'Téléphone',
      dataIndex: 'phone',
    },
    {
      title: 'Siège',
      dataIndex: 'seat',
    },
    {
      title: '',
      dataIndex: '',
      render: (_, record, index) => {
        return (
          <Button
            type="primary"
            onClick={() => {
              setIsOpenPassenger(true);
              setIndexEditPassenger(index);
            }}
            size="small">
            <IntlMessage id="global.edit" />
          </Button>
        );
      },
    },
  ];
  const [selectedRowKeys, setSelectedRowKeys] = useState(
    (currentData?.passengers &&
      currentData?.passengers.length > 0 &&
      currentData?.passengers?.map((item, index) => item.id)) ||
      []
  );
  const onSelectChange = (newSelectedRowKeys) => {
    console.log('newSelectedRowKeys', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
    setShowSearchResult(false);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    if (currentData) {
      dispatch(
        updateSearchBookingValues({
          passengers:
            currentData?.passengers &&
            currentData?.passengers.length > 0 &&
            currentData?.passengers
              ?.filter((item) => selectedRowKeys.includes(item.id))
              .map((i) => {
                return {
                  firstname: i.firstname,
                  lastname: i.lastname,
                  phone_code: '+221',
                  mobile: i.phone.slice(3),
                  passport: i.passport,
                  id: i.id,
                };
              }),
        })
      );
    }
  }, [currentData, selectedRowKeys]);

  const items = [
    {
      key: '1',
      label: <IntlMessage id="global.depart" />,
      children: (
        <Text>{currentData?.order_items?.[0]?.segment?.start_stop?.title}</Text>
      ),
      span: 4,
    },
    {
      key: '2',
      label: <IntlMessage id="global.arrivee" />,
      children: (
        <>
          <Space direction="vertical" size={'small'}>
            <Text>
              {currentData?.order_items?.[0]?.segment?.end_stop?.title}
            </Text>
          </Space>
        </>
      ),
      span: 4,
    },
    {
      key: '3',
      label: <IntlMessage id="global.date" />,
      children: (
        <>
          <Text>
            {dayjs(currentData?.date).locale('fr').format('dddd D MMMM YYYY')}
          </Text>
          <Text>
            {' '}
            {dayjs(
              currentData?.order_items?.[0]?.segment?.start_time,
              'HH:mm:ss'
            )
              .locale('fr')
              .format('HH:mm')}
          </Text>
        </>
      ),
      span: 4,
    },
    {
      key: '4',
      label: <IntlMessage id="global.company" />,
      children: (
        <>
          <Space direction="vertical" size={'small'}>
            <Text>{currentData?.route?.operator?.title}</Text>
          </Space>
        </>
      ),
      span: 4,
    },
  ];
  return (
    <React.Fragment>
      <Modal
        title={
          currentData ? (
            <IntlMessage id="order.rebook" />
          ) : (
            <IntlMessage id="order.create" />
          )
        }
        open={isModalForm}
        onCancel={onModalFormClose}
        width={'80%'}
        footer={[
          <>
            <Button key="back" type="default" onClick={onModalFormClose}>
              {<IntlMessage id="global.cancel" />}
            </Button>
            {/* <Button
              key="back"
              type="primary"
              onClick={handleOk}
              loading={isLoadingSave}
            >
              {<IntlMessage id="global.save" />}
            </Button> */}
          </>,
        ]}>
        {!currentData && (
          <SearchBus
            onFilter={filter}
            setFilter={setFilter}
            searchOrder={handleSearchOrder}
            currentData={currentData}
          />
        )}
        <Title level={5}>
          <IntlMessage id="global.select_customer" />
        </Title>

        {/* <Text>Is walk-in customer?</Text> */}
        <div style={{ marginBottom: '20px' }}>
          {currentData ? (
            <>
              {currentData?.passengers ? (
                <Table
                  columns={columnsAddPassenger}
                  dataSource={
                    (currentData?.passengers &&
                      currentData?.passengers.map((item) => {
                        let temp = searchValues.passengers.find(
                          (option) => option.id === item.id
                        );
                        let phone_code = '';
                        if (item?.phone_code?.startsWith('+')) {
                          phone_code = item.phone_code.slice(1);
                        } else {
                          phone_code = item.phone_code;
                        }
                        if (!temp) {
                          return {
                            ...item,
                          };
                        }
                        if (temp?.phone_code?.startsWith('+')) {
                          phone_code = temp.phone_code.slice(1);
                        } else {
                          phone_code = temp.phone_code;
                        }
                        return {
                          ...item,
                          ...temp,
                          phone: phone_code + temp.mobile,
                        };
                      })) ||
                    []
                  }
                  bordered
                  pagination={false}
                  style={{ width: '100%' }}
                  rowSelection={rowSelection}
                  rowKey={'id'}
                />
              ) : null}
              <Title level={5}>
                <IntlMessage id="global.departure_info" />
              </Title>
              <Row gutter={16} style={{ marginBottom: '10px' }}>
                <Col span={14}>
                  <Descriptions
                    bordered
                    items={items}
                    style={{ width: '100%', height: '100%' }}
                  />
                </Col>

                {/* <Col span={6}>
                  <Card
                    title={
                      <>
                        <Row justify={'space-between'}>
                          <Col>
                            <Text>
                              <IntlMessage id="global.subtotal" />
                            </Text>
                          </Col>
                          <Currency
                            style={{ fontSize: '16px' }}
                            value={currentData?.subtotal}
                          />
                        </Row>
                        <Row justify={'space-between'}>
                          <Col>
                            <Text>
                              <IntlMessage id="global.service_fee" />
                            </Text>
                          </Col>
                          <Col>
                            <Currency
                              style={{ fontSize: '16px' }}
                              value={currentData?.service_fee}
                            />
                          </Col>
                        </Row>
                        <Row justify={'space-between'}>
                          <Col>
                            <Text>
                              <IntlMessage id="global.total" />
                            </Text>
                          </Col>
                          <Col>
                            <Currency
                              style={{ fontSize: '16px' }}
                              value={currentData?.total}
                            />
                          </Col>
                        </Row>
                      </>
                    }></Card>
                </Col> */}
              </Row>
            </>
          ) : (
            <>
              <Button
                type="primary"
                onClick={() => {
                  setIndexEditPassenger(null);
                  setIsOpenPassenger(true);
                }}
                disabled={!showSearchResult}>
                <IntlMessage id="global.add_new_customer" />
              </Button>
              {isShowPassenger &&
                searchValues.passengers &&
                searchValues.passengers.length > 0 && (
                  <Table
                    columns={columns}
                    dataSource={
                      (searchValues.passengers &&
                        searchValues.passengers.map((item) => {
                          let phone_code = '';
                          if (item?.phone_code?.startsWith('+')) {
                            phone_code = item.phone_code.slice(1);
                          } else {
                            phone_code = item.phone_code;
                          }
                          return {
                            ...item,
                            phone: phone_code + item.mobile,
                          };
                        })) ||
                      []
                    }
                    bordered
                    pagination={false}
                    style={{ width: '100%' }}
                  />
                )}
            </>
          )}
        </div>
        {currentData && (
          <SearchBus
            onFilter={filter}
            setFilter={setFilter}
            searchOrder={handleSearchOrder}
            currentData={currentData}
            selectedRowKeys={selectedRowKeys}
          />
        )}
        <Form
          name="basic"
          labelAlign="left"
          {...layout}
          className="ml-20"
          initialValues={{
            customer_id: currentData?.customer?.id ?? undefined,
          }}
          form={form}
          // onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          autoComplete="off">
          {/* <Form.Item
            label={<IntlMessage id="global.customers" />}
            name="customer_id"
            style={{ display: 'none' }}
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Select
              showSearch
              allowClear
              placeholder="Select a customer"
              onChange={onChangeSelectCustomer}
              onSearch={handleSearchCustomer}
              filterOption={false}
              options={customersData}
            />
          </Form.Item> */}

          {isLoadingSearchResult ? (
            <LoadingContent />
          ) : showSearchResult ? (
            departureSearchData && departureSearchData.length > 0 ? (
              <Departure
                searchData={departureSearchData}
                onRefresh={onRefresh}
                onModalFormClose={onModalFormClose}
                currentData={currentData}
                handleSelectSegment={handleSelectSegment}
              />
            ) : (
              <Empty
                description={
                  <Space direction="vertical" size="small">
                    <FrownOutlined style={{ fontSize: '24px' }} />
                    <Text>Not found any route</Text>
                  </Space>
                }
              />
            )
          ) : null}

          {isLoadingSearchResult ? null : showSearchResult ? (
            returnSearchData && returnSearchData.length > 0 ? (
              <ReturnDestination
                searchData={returnSearchData}
                onRefresh={onRefresh}
                onModalFormClose={onModalFormClose}
              />
            ) : null
          ) : null}
          {segment && (
            <Flex style={{ marginTop: 16 }} vertical align="center" gap={5}>
              {!currentData && (
                <>
                  <div>
                    <IntlMessage id="global.payment_methods" />
                  </div>
                  <Radio.Group
                    style={{ width: '40%' }}
                    onChange={onChangePaymentMethod}
                    value={payMethod}>
                    <Space
                      direction="vertical"
                      align="start"
                      style={{ width: '100%' }}>
                      {payMethods &&
                        payMethods.length > 0 &&
                        payMethods.map((item) => {
                          return (
                            <>
                              <Radio value={item.method}>{item?.display}</Radio>
                              {payMethod === item.method && (
                                <Row gutter={[8, 8]}>
                                  <Col span={8}>
                                    <Form.Item
                                      name={'phone_code'}
                                      initialValue={'+221'}>
                                      <Select
                                        style={{ width: '100%' }}
                                        placeholder="Select phone code"
                                        showSearch
                                        defaultValue={`+221`}
                                        options={CountryData.map(
                                          (country, i) => {
                                            return {
                                              label: `(+${country.code}) ${country.country}`,
                                              value: `+${country.code}`,
                                            };
                                          }
                                        )}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={16}>
                                    <Form.Item
                                      name={'mobile'}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <IntlMessage id="global.requiredfield" />
                                          ),
                                        },
                                        {
                                          message: (
                                            <IntlMessage
                                              id={`global.numberfield`}
                                            />
                                          ),
                                          pattern: new RegExp(/^[0-9]+$/),
                                        },
                                      ]}>
                                      <Input />
                                    </Form.Item>
                                  </Col>
                                </Row>
                              )}
                            </>
                          );
                        })}

                      <Radio value={'pay_later'}>Pay later</Radio>
                    </Space>
                  </Radio.Group>
                </>
              )}
              <Form.Item
                label={<IntlMessage id="global.notes" />}
                name="notes"
                style={{ marginTop: 20, width: '40%' }}>
                <Input.TextArea
                  placeholder={intl.formatMessage({
                    id: 'global.input_order_notes',
                  })}
                  rows={4}
                />
              </Form.Item>
              <Button
                htmlType="submit"
                loading={isLoadingSave}
                onClick={handleCreateBooking}
                style={{
                  background: '#14bb8c',
                  color: '#FFF',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'center',
                }}>
                <IntlMessage
                  id={currentData ? 'global.valider' : 'order.create'}
                />
              </Button>
            </Flex>
          )}
        </Form>
      </Modal>
      {isOpenPassenger && (
        <PassengerInfo
          isOpenPassenger={isOpenPassenger}
          setIsOpenPassenger={setIsOpenPassenger}
          setIsShowPassenger={setIsShowPassenger}
          onRefresh={onRefresh}
          onModalFormClose={onModalFormClose}
          currentData={currentData}
          paxQty={indexEditassenger !== null ? 1 : paxQty}
          index_edit_passenger={indexEditassenger}
        />
      )}
    </React.Fragment>
  );
};

export default BusOrderForm;
